import * as React from "react";
import { useEffect, useState } from "react";
import { IdTooltipsDelay } from "../../constants/IdTooltipsDelay";
import { useDebounce } from "../generic/use-debounce/useDebounce";
import "./tooltip.less";
export var TooltipTrigger = function (_a) {
    var children = _a.children, visibleOnClick = _a.visibleOnClick;
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    var onMouseEnter = function () { return setVisible(true); };
    var onMouseLeave = function () { return setVisible(false); };
    var debounceHandler = useDebounce(visible, IdTooltipsDelay.standardDelay, visible);
    useEffect(function () {
        setVisible(debounceHandler);
        return function () {
            setVisible(false);
        };
    }, [debounceHandler]);
    return (React.createElement("span", { className: "tooltip tooltip--trigger", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: function () { return setVisible(visibleOnClick || false); } }, children(debounceHandler)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/TooltipTrigger.tsx
// module id = 665
// module chunks = 3